import { HsMedia } from '@hsetu/ngui-components';
import { KfmMediaGalleryComponent } from './kfm-media-gallery.component';

export async function mediaLoader(
  this: KfmMediaGalleryComponent,
  {
    ownerKey,
    pageIndex,
    pageSize,
  }: { ownerKey: string; pageIndex: number; pageSize: number },
): Promise<{
  data: HsMedia[];
  count: number;
  pageIndex?: number;
  pageSize?: number;
}> {
  const mediaResult = await this.mediaService.getByOwner(
    ownerKey,
    pageSize,
    pageIndex,
  );

  return mediaResult
    ? {
        data: mediaResult.data.map((m) => this.mapper.mapToHsMedia(m)),
        count: mediaResult.count,
      }
    : { data: [], count: 0 };
}
